import { PAGE, newRoutes } from '../routes/constants'
import { default as rawLocales } from './locales'
import { NAMESPACES } from './namespaces'

export const NAMESPACE = NAMESPACES
export type NAMESPACE = TObjectValues<typeof NAMESPACES>

export const LANG_NAMES = {
  fr: 'Français',
  es: 'Español',
  en: 'English',
  pt: 'Português',
  it: 'Italiano',
  pl: 'Polski',
}

export type TLocale = keyof typeof LANG_NAMES

export const LOCALES = rawLocales

export const UNTRANSLATABLE_PAGE_FALLBACKS = {
  [PAGE.COMMUNITY_VIEW]: newRoutes.communities(),
  [PAGE.COMMUNITY_VIEW_LANDING]: newRoutes.communities(),
}

export const APP_LOCALE_PATHS = LOCALES.map((locale) => `./i18n/${locale}/app.json`)

export const SOURCE_PATH = '.'

export const COMMON_NAMESPACES = [NAMESPACE.COMMON, NAMESPACE.AUTH, NAMESPACE.SHARE, NAMESPACE.INTENTION]
